import { render, staticRenderFns } from "./class_list.vue?vue&type=template&id=6fcd0938&scoped=true&"
import script from "./class_list.vue?vue&type=script&lang=js&"
export * from "./class_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd0938",
  null
  
)

export default component.exports